import { render, staticRenderFns } from "./companyIndex.vue?vue&type=template&id=b3b347b6&scoped=true"
import script from "./companyIndex.vue?vue&type=script&lang=js"
export * from "./companyIndex.vue?vue&type=script&lang=js"
import style0 from "./companyIndex.vue?vue&type=style&index=0&id=b3b347b6&prod&lang=css"
import style1 from "./companyIndex.vue?vue&type=style&index=1&id=b3b347b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b347b6",
  null
  
)

export default component.exports